import * as React from 'react';
import { TextButton } from '@wix/design-system';
import { Brands } from '@wix/package-picker-common';
import { useComponentsTranslations } from '../../providers/ComponentsTranslationsProvider';
export var FooterLinkCode;
(function (FooterLinkCode) {
    FooterLinkCode["TERMS_OF_USE"] = "terms_of_use";
    FooterLinkCode["PRIVACY"] = "privacy";
    FooterLinkCode["CONTACT_US"] = "contact_us";
})(FooterLinkCode || (FooterLinkCode = {}));
const FooterLinkHrefByBrand = {
    [Brands.WIX]: {
        [FooterLinkCode.TERMS_OF_USE]: 'https://www.wix.com/about/terms-of-use?referralAdditionalInfo=realDeal',
        [FooterLinkCode.PRIVACY]: 'https://www.wix.com/about/privacy?referralAdditionalInfo=realDeal',
        [FooterLinkCode.CONTACT_US]: 'https://www.wix.com/about/contact-us?referralAdditionalInfo=realDeal',
    },
    [Brands.EDITOR_X]: {
        [FooterLinkCode.TERMS_OF_USE]: 'https://www.editorx.com/info/terms-of-use',
        [FooterLinkCode.PRIVACY]: 'https://www.editorx.com/info/privacy',
        [FooterLinkCode.CONTACT_US]: 'https://www.wix.com/about/contact-us',
    },
    [Brands.DAYFUL]: {
        // TODO - Fix links once the dayful domain launches
        [FooterLinkCode.TERMS_OF_USE]: 'https://www.editorx.com/info/terms-of-use',
        [FooterLinkCode.PRIVACY]: 'https://www.editorx.com/info/privacy',
        [FooterLinkCode.CONTACT_US]: 'https://www.wix.com/about/contact-us',
    },
};
export const FooterLink = ({ brand, code, }) => {
    const { t } = useComponentsTranslations();
    const link = FooterLinkHrefByBrand[brand][code];
    return (React.createElement(TextButton, { dataHook: `footer-${code}`, size: "small", as: "a", target: "_blank", skin: "dark", href: link }, t(`footer.${code}.text`)));
};
//# sourceMappingURL=FooterLink.js.map